import { createStore } from 'vuex'
import getters from './getters'
import user from './modules/user'
import main from './modules/main'
export default createStore({
  getters,
  modules: {
    user,
    main
  }
})
